import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiCheckCircle, FiXCircle } = FiIcons;

const RedFlagsSection = ({ redFlags }) => {
  const hasRedFlags = redFlags.some(flag => !flag.includes('No significant red flags'));

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.5 }}
      className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20"
    >
      <div className="flex items-center space-x-3 mb-6">
        <SafeIcon icon={hasRedFlags ? FiAlertTriangle : FiCheckCircle} className={`text-2xl ${hasRedFlags ? 'text-red-400' : 'text-green-400'}`} />
        <h3 className="text-2xl font-bold text-white">⚠️ RED FLAGS / WARNING SIGNALS</h3>
      </div>
      <div className="space-y-3">
        {redFlags.map((flag, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className={`flex items-center space-x-3 p-4 rounded-lg border ${
              hasRedFlags ? 'bg-red-500/10 border-red-500/30 text-red-300' : 'bg-green-500/10 border-green-500/30 text-green-300'
            }`}
          >
            <SafeIcon icon={hasRedFlags ? FiXCircle : FiCheckCircle} className={`text-lg ${hasRedFlags ? 'text-red-400' : 'text-green-400'}`} />
            <span>{flag}</span>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default RedFlagsSection;